import React from 'react'
import { Deposit } from 'src/core/models'
import { CustomTag } from 'src/components'
import { useTranslation } from 'next-i18next'

const DepositsStatusColumn: React.FC<{ deposit: Deposit }> = ({ deposit }) => {
  const { t } = useTranslation()

  const tag = {
    paid: { label: t('Deposits.Completed'), type: 'success' },
    pending: { label: t('Deposits.Pending'), type: 'processing' },
    canceled: { label: t('Deposits.Canceled'), type: 'error' }
  }[deposit.status]

  return <CustomTag text={tag.label} type={tag.type} />
}

export default DepositsStatusColumn
